import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Body } from '@vds-core/typography';
import { colors, calculateSpacing } from '@vds-core/theme';
import { BodyConfig, TypographyConfig } from '@vds-core/typography';
import { calculateRem } from '@uie/javascript-style-helpers';
var propTypes = {
  active: PropTypes.bool,
  children: PropTypes.string.isRequired,
  label: PropTypes.string,
  className: PropTypes.string,

  /**
   * @ignore
   */
  bodyConfig: PropTypes.object,

  /**
   * @ignore
   */
  typescale: PropTypes.string,

  /**
   * @ignore
   */
  colorConfig: PropTypes.object,

  /**
   * @ignore
   */
  focusState: PropTypes.bool
};
var defaultProps = {
  active: false,
  className: null,
  bodyConfig: BodyConfig,
  focusState: false,
  colorConfig: colors,
  typescale: TypographyConfig.getTypescale()
};
var StyledBreadcrumbSpan = /*#__PURE__*/styled(Body).withConfig({
  displayName: "StyledBreadcrumbSpan",
  componentId: "sc-1hgr4wl-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: default;\n  transition: color 0.15s ease-out;\n  padding-bottom: ", ";\n"])), calculateSpacing('1X', 'rem'));
/**
 * @ignore
 */

var BreadcrumbSpan = function BreadcrumbSpan(_ref) {
  var label = _ref.label,
      active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      colorConfig = _ref.colorConfig,
      bodyConfig = _ref.bodyConfig,
      typescale = _ref.typescale,
      inverted = _ref.inverted,
      ariaLabel = _ref.ariaLabel,
      analyticsTrack = _ref['data-analyticstrack'],
      track = _ref['data-track'],
      clickStream = _ref['data-clickstream'];

  function fontWeight() {
    return active ? '700' : '400';
  }

  function color() {
    if (active && !inverted) return colorConfig.black;else if (active && inverted) return colorConfig.white;else return colorConfig.coolGray6;
  }

  return /*#__PURE__*/React.createElement(StyledBreadcrumbSpan, {
    getFontWeight: fontWeight,
    typescale: typescale,
    config: bodyConfig,
    "aria-label": ariaLabel ? ariaLabel : label,
    "aria-selected": active,
    "aria-current": active ? 'page' : null,
    active: active,
    className: className,
    primitive: "span",
    size: "small",
    color: color(),
    "data-analyticstrack": analyticsTrack,
    "data-track": track,
    "data-clickstream": clickStream
  }, children);
};

BreadcrumbSpan.propTypes = propTypes;
BreadcrumbSpan.defaultProps = defaultProps;
export default BreadcrumbSpan;